import NewCustomerMap from './NewCustomerMap'

export default NewCustomerMap
